$ = require 'jquery'
_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
Promise = require 'bluebird'
{ ROUTES } = require '@trello/routes'
{ navigate } = require 'app/scripts/controller/navigate'

normalize = (name) ->
  name.toLowerCase().replace(/[-_()\[\]:,]/g, ' ').replace(/\s+/g, ' ')

# A search for t-h would match "T H"
exactMatch = (boards, search) ->
  normalizedSearch = normalize(search)
  _.find boards, (board) -> normalize(board.get('name')) == normalizedSearch

searchWords = (search) ->
  search.toLowerCase().split(/[-_ ]/)

# A search for t-h would match "Town Hall" but not "Head Stand"
prefixMatch = (boards, search) ->
  words = searchWords(search)
  _.find boards, (board) ->
    nameWords = searchWords(normalize(board.get('name')))
    _.all words, (word) ->
      _.any nameWords, (nameWord) -> nameWord.indexOf(word) == 0

# A search for t-h would match "Sixth"
fuzzyMatch = (boards, search) ->
  words = searchWords(search)
  _.find boards, (board) ->
    name = normalize(board.get('name'))
    _.all words, (word) -> name.indexOf(word) != -1

openBoard = (board) -> board.isOpen()

boardDateLastActive = (board) ->
  -(new Date(board.get('dateLastActivity')))

fixSpaces = (search) ->
  search.replace(/[-_ ]+/g, ' ')

module.exports =
  routes: [
    [ROUTES.GO.route, 'quickBoard']
    [ROUTES.TO.route, 'quickBoard']
    [ROUTES.DOUBLE_SLASH.route, 'quickBoard']
  ]

  quickBoard: (search) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    search = decodeURIComponent(search)

    if !Auth.isLoggedIn()
      window.location = "/login?returnUrl=#{ encodeURIComponent("//" + search) }"
      return

    # Quick board route of "//" should redirect back to home
    if search is ""
      navigate("/", { trigger: true })
      return

    # We've already triggered this exact load in quick load
    Promise.using @getSpinner(), =>
      Promise.all([
        ModelLoader.await('headerData').then =>
          @showHeader()

        Promise.try ->
          if search
            ModelLoader.for 'top-level', 'loadQuickBoardsSearch', fixSpaces(search)

        ModelLoader.for 'top-level', 'loadQuickBoardsData'
      ])
      .then =>
        me = Auth.me()

        starredBoards = me.boardStarList.chain()
          .invoke 'getBoard'
          .compact() # Might have a closed board starred
          .filter(openBoard)
          .value()

        myBoards = me.boardList.chain()
          .filter(openBoard)
          .sortBy(boardDateLastActive)
          .value()

        orgBoards = me.organizationList.chain()
          .pluck('boardList')
          .pluck('models')
          .flatten()
          .filter(openBoard)
          .sortBy(boardDateLastActive)
          .value()

        matchers = [exactMatch, prefixMatch, fuzzyMatch]
        boardGroups = [starredBoards, myBoards, orgBoards]

        for matcher in matchers
          for boardGroup in boardGroups
            if (bestMatch = matcher(boardGroup, search))?
              # Replace the URL, so the back button doesn't get confused
              history.replaceState null, null, @getBoardUrl(bestMatch) + location.search
              @displayBoard { idBoard: bestMatch.id }
              return

        navigate("/search?q=#{ encodeURIComponent(fixSpaces(search)) }", { trigger: true })
    .done()
    return
